export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';